import React, { useState, useEffect } from 'react';
// import Image from 'next/image'
// import { useRouter } from 'next/navigation';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { login, logout, selectUser } from '../../../provider/features/userSlice';
import { UserCircleIcon } from '@heroicons/react/24/solid'
import ApplicationGuide from './ApplicationGuide';
import GuideButton from './GuideButton';

function NavBarClient() {
  const [showGuide, setShowGuide] = useState(false);
  const dispatch = useDispatch();
  // const router = useRouter();
  let navigate = useNavigate();
  const [user, setUser] = useState<any>();
  
  useEffect(() => {
    if (localStorage.getItem('currentUser')) {
      let uData: string = JSON.parse(localStorage.getItem('currentUser') ?? '{}');
      setUser(uData);
    }
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      // Your function to be called after 5 seconds
      if (localStorage.getItem('currentUser')) {
        let uData: string = JSON.parse(localStorage.getItem('currentUser') ?? '{}');
        setUser(uData);
      }
    }, 5000);

    // Clean up the timeout to avoid memory leaks
    return () => clearTimeout(timeoutId);
  }, [])

  const handleLogout = () => {
    try {
      dispatch(logout());
      localStorage.setItem('is_login','no');
      localStorage.removeItem('currentUser');
      // router.push('/welcome');
      navigate("/welcome", { replace: true });
      // window.location.href="/";
    } catch (err) {
      // console.log(err?.response.data);
    }
  }
  const handleGuideOpen = () => {
    setShowGuide(true);
  };

  const handleGuideClose = () => {
    setShowGuide(false);
  };

  return (
    <>
      {/* <div className="bg-[#923d41] grid grid-cols-2 justify-center pl-2"> */}
      <div className="bg-[#923d41] flex justify-between  pl-2 pb-2">
        <span className='banner_title text-[0.9rem] md:text-[0.9rem] lg:text-[1.10rem] text-center m-0 p-0 text-[#fff] pb-1'>
          Fee Payment Portal
        </span>
        <div className='px-2'>
            <GuideButton onClick={handleGuideOpen} />

        </div>
      </div>
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 items-start shadow-sm rounded-xl border-t-2 border-white rounded-t-none bg-[#923d41]'>
        <div id="logo" className="flex items-center md:items-start justify-center md:justify-start bg-color pl-4">
          <div className="ui raised logo mt-0 mb-0 segment alpha bg-gray-900" style={{ backgroundColor: '#923d41' }}>
            <img 
              src="https://svcs-image.dreamapply.com/eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpc3MiOiJkcmVhbS1hcHBseSIsImF1ZCI6ImRyZWFtLWltYWdlIiwicGxkIjp7InBhdGgiOiJkcmVhbS1hcHBseTpzaGFyZDgxMy9pbnN0YW5jZV9sb2dvcy9kMjZmYzFiZC1hN2NiLTRhYzktYmFmZC0xNTk2ZmFiZWU1YjEiLCJ0cmFuc2Zvcm1hdGlvbnMiOlt7Im5hbWUiOiJmaXQiLCJwYXJhbXMiOnsid2lkdGgiOiI0MjAiLCJoZWlnaHQiOiIyMDAiLCJxdWFsaXR5IjoiOTUiLCJleHRlbmQiOiIyNTUsMjU1LDI1NSJ9fV0sImNhY2hlIjoibWF4LWFnZT0zMTUzNjAwMCwgcHVibGljIiwib3V0cHV0X2Zvcm1hdCI6InNhbWUiLCJhdHRhY2giOm51bGwsInNka192ZXJzaW9uIjoiMS4wIn19.NKQnUlTNK9rV-QhV8NFMtzSixM6Gtn4pjC2B3t9_Pb2N2Vtwq7-dnKzAzDJd8OINXq5jrfmibHwN3aNrTs4LyLeAm9v-Gufl9KpRYZ7WtqLq5bhlaUuGSzdPp1B9DAONj91S1reRfuxk1zEvfJXnOv5cGA01zJ2uomDnamp1ZACkt8L7Su3e_9cuEu15rgTIN8Z3Ezux1O7ZKqjRO-fm7qZSNG3NW8SMMixtux7TcRHYySzH7glIbvbgvIfGTPj2A8rS0jMlBbtY6e5wdKmGBV2wGwKr1LwhzpvQsqsqtW8m8Ax6UKyEfHBLLmZ9vYtTkH6tFDu0kyTk2vkqGWa5qw"
              alt='logo'
              width={200}
              height={100}
            />
          </div>
        </div>
        
        <div className='min-h-[100px] bg-[#923d41] px-4 md:p-0 flex items-center'>
          {/* Redesigned user info section - Option 1: Wine theme with light text */}
          <div className='flex flex-wrap md:flex-nowrap items-center justify-around w-full mb-2 mt-2 p-3 rounded-full bg-[#7a2e32] border border-[#a8555a] shadow-lg'>
            <UserCircleIcon className="h-[50px] w-[50px] text-[#e8d5d5] flex-shrink-0" />
            
            <div className='grid grid-cols-1 text-[0.85rem] mx-2 flex-1 min-w-[150px]'>
              <p className='truncate text-[#f5e6e6]'>
                <span className='font-bold text-[#ffd4d4]'>Applicant</span>:  
                <span className='ml-1 text-white'> {user?.full_name || 'N/A'}</span>
              </p>
              <p className='text-[#f5e6e6]'>
                <span className='font-bold text-[#ffd4d4]'>ID</span>:  
                <span className='ml-1 text-white'>{user?.applicant_id || 'N/A'}</span>
              </p>
              <p className='truncate text-[#f5e6e6]'>
                <span className='font-bold text-[#ffd4d4]'>Email</span>:  
                <span className='ml-1 text-white'>{user?.email || 'N/A'}</span>
              </p>
            </div>
            <button 
              className='btn btn-xs shadow rounded-full text-[0.85rem] px-4 py-1 bg-[#c0392b] hover:bg-[#e74c3c] text-white border border-[#e8d5d5] transition-colors duration-200 flex-shrink-0'
              onClick={() => handleLogout()}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
        {/* Application Guide Modal */}
      <ApplicationGuide 
        isOpen={showGuide}
        onClose={handleGuideClose}
      />
    </>
  )
}

export default NavBarClient;